import React from "react";
import { Icon, Position } from "@blueprintjs/core";
import { Link } from "react-router-dom";
import { Tooltip } from "components/tooltip";
import { ShowHide } from "components/layout";
import { Numeric } from "components/formatting";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./HubTile.css";

export function HubTile({
    isLoading = false,
    title = "Hub Tile",
    count = 0,
    totalCount = 0,
    colour = "",
    link = "/",
    description = "",
    fullWidth = false,
    setGraphHover = () => {}
}) {
    function handleMouseEnter() {
        if (count === 0){
            return;
        }

        setGraphHover({ title, count, totalCount, colour });
    }

    function handleMouseLeave() {
        if (count === 0){
            return;
        }

        setGraphHover(null);
    }
    return (
        <Link
            to={link}
            className={classNames("hub-tile-link", {
                "hub-tile-disabled": count === 0,
                "hub-tile-full-width": fullWidth,
            })}
        >
            <button
                className={classNames("hub-tile", {
                    "hub-tile-disabled": count === 0,
                    "bp6-skeleton": isLoading,
                })}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <div className="hub-tile-inner">
                    <h6>
                        {title}
                        <ShowHide
                            evaluator={description != null && description !== ""}
                            show={
                                <Tooltip
                                    position={Position.RIGHT}
                                    content={
                                        <div>
                                            <h4>{title}</h4>
                                            <p>{description}</p>
                                        </div>
                                    }
                                >
                                    <Icon
                                        className="hub-tool-tip"
                                        icon="info-sign"
                                        size={10}
                                        color={count > 0 ? "#0C2235" : "#C2C7CC"}
                                    />
                                </Tooltip>
                            }
                        />
                    </h6>
                    <div>
                        <p
                            style={{
                                color: colour && count > 0 ? colour : "#C2C7CC",
                            }}
                        >
                            <Numeric>{count}</Numeric>
                        </p>
                        <div className="hub-tile-footer">
                            <p>View</p>
                            <Icon icon="chevron-right" size={20} />
                        </div>
                    </div>
                </div>
            </button>
        </Link>
    );
}

HubTile.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string,
    count: PropTypes.number,
    totalCount: PropTypes.number,
    colour: PropTypes.string,
    link: PropTypes.string,
    description: PropTypes.string,
    fullWidth: PropTypes.bool,
    setGraphHover: PropTypes.func,
};
